export const PLAYLIST_URL = "https://docs.google.com/spreadsheets/d/1oLJZRqhh3isarsffJC5RO6z-MYc7kjZCKwvuAF0IirQ/gviz/tq?tqx=out:csv";
export const CALENDAR_ID = 'MjAwNWMwOTE3NmUzMDRkYjBmMTA3N2NjYWU0MGRmZTE4YzA2ZTRhMmNhMTVhOTdiOGE2YWE2MDQ2MGVlM2IyZUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t';
